import React, { useState } from 'react'
import { Menu, MenuItem, Position } from '@blueprintjs/core'
import { Button, Flex, Popover } from '@ui'
import LocationSearch from './Search'
import useLocations from './useLocations'
import { IUIButtonProps } from '@ui/buttons/Button'
import { CityColumn, Building } from './helperComponents'
import { get, without } from 'lodash'
import { Mode } from './types'
import { IBuildingDetails, IPortfolioCity } from '@api'
import css from './locationSelect.module.scss'

interface MultiBuildingSelectProps {
  values: IBuildingDetails[]
  buttonProps?: IUIButtonProps
  onChange: (value: any) => void
  includeOldBuildings?: boolean
}

/**
 * This is a helper component which should not be used directly.
 * Use @ui/selectes/MultiLocationSelect instead.
 */
export default function MultiBuildingSelect({
  values,
  buttonProps,
  onChange,
  includeOldBuildings,
}: MultiBuildingSelectProps) {
  const regions = useLocations(includeOldBuildings)
  const [cityNav, setCityNav] = useState<IPortfolioCity | null>(null)
  const buildings: IBuildingDetails[] = get(cityNav, 'buildings', [])

  return (
    <Popover
      minimal
      usePortal
      position={Position.BOTTOM}
      content={
        <div className={css.container}>
          <LocationSearch
            mode={Mode.MULTI_BUILDING}
            regions={regions}
            selectCity={setCityNav}
            selectBuilding={(building) =>
              onChange(
                values.includes(building) ? without(values, building) : [...values, building]
              )
            }
            selectFloor={() => null}
          />
          <Flex>
            <CityColumn regions={regions} cityNav={cityNav} setCityNav={setCityNav} />
            <div className={css.col} style={{ minWidth: 300 }}>
              <div className={css.col_header} style={{ paddingLeft: 11 }}>
                buildings
              </div>
              {buildings.length ? (
                <div className={css.list}>
                  <Menu>
                    {buildings.map((b) => (
                      <div key={b.id} style={{ borderBottom: '1px solid #eee' }}>
                        <MenuItem
                          onClick={(e) => {
                            e.preventDefault()
                            onChange(values.includes(b) ? without(values, b) : [...values, b])
                          }}
                          shouldDismissPopover={false}
                          text={
                            <Building
                              mode={Mode.MULTI_BUILDING}
                              building={b}
                              selected={values.includes(b)}
                            />
                          }
                        />
                      </div>
                    ))}
                  </Menu>
                </div>
              ) : (
                <Menu>
                  <MenuItem disabled text="No buildings" />
                </Menu>
              )}
            </div>
          </Flex>
        </div>
      }
    >
      <Button {...buttonProps} />
    </Popover>
  )
}
